/**********************************************************************************************************************
 * Responsibility: This component is responsible for rendering the action items for each archived order. 🐺
 * ********************************************************************************************************
 *
 * @format
 * */

import {UnArchiveOrder} from '../../actions/unarchive_order_modal';
import {PRODUCT_TYPE_GRAPHIC_DESIGN} from 'frontier-constants';
import {If} from 'frontier-utilities';
import React, {useEffect} from 'react';

// styles
import './action_column.scss';

export const ActionColumn = props => {
    const {order, onSuccessfulSave, onError} = props;

    const viewShippingSummaryPath = `/account/orders/preview-cart-summary/${order.cart_id}`;
    const viewInvoicePath = `/account/orders/preview-current-invoice/${order.cart_id}`;

    return (
        <div className="designs_table__action-column-12bg">
            <a
                className="d-flex align-items-center justify-content-start color-accent-primary gap-2"
                rel="noopener noreferrer"
                href={viewInvoicePath}
                target="_blank">
                <i className="fa fa-eye" />
                <span>Invoice</span>
            </a>
            <If condition={order.product_type_id !== PRODUCT_TYPE_GRAPHIC_DESIGN}>
                <a
                    className="d-flex align-items-center justify-content-start color-accent-primary gap-2"
                    href={viewShippingSummaryPath}
                    rel="noopener noreferrer"
                    target="_blank">
                    <i className="fa fa-truck" />
                    <span>Shipping summary</span>
                </a>
            </If>
            <UnArchiveOrder order={order} onArchive={onSuccessfulSave} />
        </div>
    );
};
